export default __webpack_public_path__ + "static/media/TRANSPARENT.2d4bd5b0.svg";